// wishlist overrides
function replaceLabelTextPreserveSpan(label, fromText, toText) {
  if (!label) return;

  const textNodes = Array.from(label.childNodes).filter(
    (node) => node.nodeType === Node.TEXT_NODE
  );

  textNodes.forEach((node) => {
    const trimmed = node.textContent.trim();
    if (trimmed === fromText) {
      node.textContent = node.textContent.replace(fromText, toText);
    }
  });
}

function updateWishlistTitle() {
  const wishlistTitle = document.querySelector(
    ".hulk__wishlist-wrap ul.sidebar_list .sidebar_item [data-hulkwishlisttitle]"
  );
  if (wishlistTitle) {
    if (wishlistTitle.textContent.trim().includes("My Wishlist")) {
      wishlistTitle.textContent = wishlistTitle.textContent.replace("My Wishlist", "Default Project");
    }
    wishlistTitle.classList.add("is-visible");
  }
}

function updateNewWishlistBtn() {
  const newWishlistBtn = document.querySelector("[data-newwishlistadd]");
  if (newWishlistBtn) {
    if (newWishlistBtn.textContent.trim().includes("New wishlist")) {
      newWishlistBtn.textContent = newWishlistBtn.textContent.replace("New wishlist", "New Project");
    }
    newWishlistBtn.classList.add("is-visible");
  }
}

function updatePopupWishlistLabels() {
  const popupLabels = document.querySelectorAll(
    ".hulk__wishlist-wrap .choose-wishlist-option .wishlist-checkbox"
  );

  popupLabels.forEach((label) => {
    replaceLabelTextPreserveSpan(label, "My Wishlist", "Default Project");
    replaceLabelTextPreserveSpan(label, "New wishlist", "New Project");
  });
}

function updateWishlistButtons() {
  const buttonLabels = document.querySelectorAll("[data-wishList] span:not(.count)");

  buttonLabels.forEach((label) => {
    if (label.textContent.trim() === "Add to wishlist") {
      label.textContent = "Add to Project";
    }
  });
}

function updateProductCardLabels() {
  const wrappers = document.querySelectorAll("[data-wishlist-wrapper]");
  wrappers.forEach((wrapper) => {
    const btn = wrapper.querySelector("[data-wishList]");
    const label = wrapper.querySelector(".product-card-wishlist-label");
    if (!btn || !label) return;
    label.textContent = btn.dataset.added !== "false" ? "Added to Project" : "Add to Project";
  });
}

function isInWishlistWrap(node) {
  return node && (
    (node.nodeType === Node.ELEMENT_NODE && node.closest && node.closest(".hulk__wishlist-wrap")) ||
    (node.nodeType === Node.TEXT_NODE && node.parentElement && node.parentElement.closest(".hulk__wishlist-wrap"))
  );
}

const wishlistObserver = new MutationObserver((mutations) => {
  let relevantWrap = false;
  let relevantCard = false;

  mutations.forEach((m) => {
    if (isInWishlistWrap(m.target)) {
      relevantWrap = true;
    }
    if (m.type === "attributes" && m.attributeName === "data-added" && m.target.matches && m.target.matches("[data-wishList]")) {
      relevantCard = true;
    }
    if (m.addedNodes) {
      for (const n of m.addedNodes) {
        if (n.nodeType === Node.ELEMENT_NODE) {
          if ((n.matches && n.matches(".hulk__wishlist-wrap")) || (n.querySelector && n.querySelector(".hulk__wishlist-wrap"))) {
            relevantWrap = true;
          }
          if ((n.matches && n.matches("[data-wishList]")) || (n.querySelector && n.querySelector("[data-wishList]"))) {
            relevantCard = true;
          }
        }
      }
    }
  });

  if (relevantWrap) {
    updateWishlistTitle();
    updateNewWishlistBtn();
    updatePopupWishlistLabels();
    updateWishlistButtons();
  }
  if (relevantWrap || relevantCard) {
    updateProductCardLabels();
  }
});

updateWishlistTitle();
updateNewWishlistBtn();
updatePopupWishlistLabels();
updateWishlistButtons();
updateProductCardLabels();

if (document.body) {
  wishlistObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeFilter: ["data-added"]
  });
} else {
  document.addEventListener("DOMContentLoaded", () => {
    updateWishlistTitle();
    updateNewWishlistBtn();
    updatePopupWishlistLabels();
    updateWishlistButtons();
    updateProductCardLabels();

    wishlistObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true,
      attributes: true,
      attributeFilter: ["data-added"]
    });
  });
}

// DataLayer: track add_to_wishlist events via HulkApps wishlist buttons
document.addEventListener('click', function(e) {
  const wishlistBtn = e.target.closest('[data-wishList]');
  if (!wishlistBtn) return;

  if (wishlistBtn.dataset.added !== 'false') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'add_to_wishlist',
    ecommerce: {
      items: [{
        item_id: wishlistBtn.dataset.proid || '',
        item_name: wishlistBtn.dataset.productTitle || '',
        item_variant: wishlistBtn.dataset.varid || ''
      }]
    }
  });
});